import { useMemo } from 'react';
import { GridColDef } from '@mui/x-data-grid-premium';
import dayjs from 'dayjs';
import { FlightIdentifier } from '@aviation/cabinapp-cabincast-sdk';
import { useFetch } from '../../../hooks/useFetch';
import ReadOnlyGridDialog from './ReadOnlyGridDialog';

const formatDate = (value?: string) => {
    if (!value) return '';
    const date = dayjs(value);
    return date.isValid() ? date.toDate().toLocaleDateString() : value;
};

const columns: GridColDef[] = [
    { field: 'FlightDate', headerName: 'Date', width: 130, valueFormatter: (params) => formatDate(params.value) },
    { field: 'Al', headerName: 'Airline', width: 100 },
    { field: 'No', headerName: 'Flight no.', width: 120 },
    { field: 'Dep', headerName: 'Departure', width: 120 },
    { field: 'Dest', headerName: 'Destination', width: 120, flex: 1 },
];

export interface IAudioFileFlightsDialogProps {
    open: boolean;
    audioFileId: string;
    onClose: () => void;
}

function AudioFileFlightsDialog({ open, audioFileId, onClose }: IAudioFileFlightsDialogProps) {
    // An empty URL makes useFetch skip the request until the dialog is opened.
    const { status, data } = useFetch<FlightIdentifier[]>(
        open ? `/api/audiofiles/${audioFileId}/assignments` : '',
        (response) => Array.isArray(response) ? response : (response?.Items ?? []),
        0, true);

    const rows = useMemo(() => (data ?? [])
        .map((f, index) => ({ ...f, id: `${f.Al}-${f.No}-${f.FlightDate}-${f.Dep}-${f.Dest}-${index}` }))
        .sort((a, b) => (a.FlightDate ?? '').localeCompare(b.FlightDate ?? '')), [data]);

    return <ReadOnlyGridDialog open={open} title='Flights' rows={rows} columns={columns} status={status} onClose={onClose} />;
}

export default AudioFileFlightsDialog;
